import { css } from '@linaria/core';

export const styledItem = css`
	display: flex;
	height: 5rem;
	flex-grow: 1;
	align-items: center;

	& div {
		height: 3px;
		flex-grow: 1;
		border-radius: var(--radius-xxs);
		background-color: var(--color-white-m);
		transition: height 0.2s ease-in-out, background-color 0.2s ease-in-out;
	}

	&.selected div {
		background-color: var(--color-white-solid);
	}

	&.current div {
		background-color: var(--color-white-solid);
	}

	&:hover.selected div {
		height: 2rem;
	}
`;
